module.exports = __webpack_public_path__ + "media/fiat/sepa-dc20c3c6.png";